var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 160,
    viewBox: "0 0 118 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.5201 40C71.14 40 62.6301 39.66 54.6601 37.44C46.8401 35.26 39.6601 31.06 33.2601 26.19C29.0601 23.01 25.2601 20.49 19.8101 20.87C14.4943 21.1481 9.40817 23.1251 5.30006 26.51C-1.62994 32.57 -0.579942 43.78 2.18006 51.66C6.35006 63.53 19.0001 71.78 29.7701 77.15C42.2001 83.36 55.8501 87 69.5501 89C81.5501 90.83 96.9601 92.15 107.36 84.31C116.92 77.11 119.54 60.67 117.2 49.57C116.632 46.2888 114.881 43.3292 112.28 41.25C105.57 36.34 95.5601 39.62 88.0201 39.78C85.2201 39.88 82.38 40 79.5201 40Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0299 108.5C79.3043 108.5 95.7399 107.475 95.7399 106.21C95.7399 104.945 79.3043 103.92 59.0299 103.92C38.7556 103.92 22.3199 104.945 22.3199 106.21C22.3199 107.475 38.7556 108.5 59.0299 108.5Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 25.8409C112.041 25.8409 112.48 25.4021 112.48 24.8609C112.48 24.3196 112.041 23.8809 111.5 23.8809C110.959 23.8809 110.52 24.3196 110.52 24.8609C110.52 25.4021 110.959 25.8409 111.5 25.8409Z",
    fill: "#CFCFCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.24 18.8604C69.7812 18.8604 70.22 18.4216 70.22 17.8804C70.22 17.3392 69.7812 16.9004 69.24 16.9004C68.6988 16.9004 68.26 17.3392 68.26 17.8804C68.26 18.4216 68.6988 18.8604 69.24 18.8604Z",
    fill: "#CFCFCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1 82.4004V86.7004",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.95 84.5508H32.25",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.33 0.550781V4.85078",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.17 2.69922H16.48",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.28 22.6992V27.0092",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M90.13 24.8594H94.43",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M53.36 80.2807C57.9798 86.7393 64.9717 91.103 72.8034 92.4151C80.635 93.7273 88.6675 91.8809 95.14 87.2807C95.94 86.713 96.711 86.1056 97.45 85.4607L109.38 89.0707L104.81 75.7207C107.091 70.9454 108.069 65.6516 107.643 60.3765C107.217 55.1014 105.404 50.0328 102.387 45.685C99.3695 41.3372 95.2558 37.8649 90.463 35.6205C85.6703 33.3761 80.3691 32.4395 75.0975 32.9057C69.8259 33.3719 64.7714 35.2243 60.4469 38.275C56.1224 41.3257 52.6819 45.466 50.4745 50.2759C48.2671 55.0857 47.3713 60.3939 47.8781 65.6618C48.3849 70.9297 50.2762 75.9698 53.36 80.2707V80.2807Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.13 64.8604C89.2235 64.8604 90.11 63.9739 90.11 62.8804C90.11 61.7869 89.2235 60.9004 88.13 60.9004C87.0365 60.9004 86.15 61.7869 86.15 62.8804C86.15 63.9739 87.0365 64.8604 88.13 64.8604Z",
    fill: "#BABABA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.58 64.8604C79.6735 64.8604 80.56 63.9739 80.56 62.8804C80.56 61.7869 79.6735 60.9004 78.58 60.9004C77.4865 60.9004 76.6 61.7869 76.6 62.8804C76.6 63.9739 77.4865 64.8604 78.58 64.8604Z",
    fill: "#BABABA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0401 64.8604C70.1336 64.8604 71.0201 63.9739 71.0201 62.8804C71.0201 61.7869 70.1336 60.9004 69.0401 60.9004C67.9465 60.9004 67.0601 61.7869 67.0601 62.8804C67.0601 63.9739 67.9465 64.8604 69.0401 64.8604Z",
    fill: "#BABABA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.14 59.8703C58.5203 66.3289 51.5283 70.6926 43.6967 72.0047C35.865 73.3169 27.8326 71.4705 21.36 66.8703C20.5577 66.3057 19.7866 65.6982 19.05 65.0503L7.12 68.6803L11.69 55.3203C9.40877 50.545 8.43137 45.2512 8.85696 39.9761C9.28256 34.701 11.096 29.6324 14.1133 25.2846C17.1306 20.9368 21.2443 17.4645 26.037 15.2201C30.8298 12.9757 36.1309 12.0391 41.4025 12.5053C46.6742 12.9715 51.7287 14.8239 56.0531 17.8746C60.3776 20.9253 63.8181 25.0656 66.0255 29.8755C68.2329 34.6853 69.1287 39.9936 68.6219 45.2614C68.1152 50.5293 66.2239 55.5694 63.14 59.8703Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.07 43.96C50.1635 43.96 51.05 43.0735 51.05 41.98C51.05 40.8865 50.1635 40 49.07 40C47.9764 40 47.09 40.8865 47.09 41.98C47.09 43.0735 47.9764 43.96 49.07 43.96Z",
    fill: "#BABABA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5199 43.96C40.6134 43.96 41.4999 43.0735 41.4999 41.98C41.4999 40.8865 40.6134 40 39.5199 40C38.4264 40 37.5399 40.8865 37.5399 41.98C37.5399 43.0735 38.4264 43.96 39.5199 43.96Z",
    fill: "#BABABA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.98 43.96C31.0735 43.96 31.96 43.0735 31.96 41.98C31.96 40.8865 31.0735 40 29.98 40C28.8865 40 28 40.8865 28 41.98C28 43.0735 28.8865 43.96 29.98 43.96Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChat);
export default __webpack_public_path__ + "static/media/NoChat.0c96b0081f313820b8272c9901af76fd.svg";
export { ForwardRef as ReactComponent };